import { Chip } from "@mui/material";
import { RaRecord } from "react-admin";

const SiteNumberTextField = ({ record }: { record: RaRecord }) => {
  return <Chip label={record.site_ids.length} sx={{ bgcolor: "primary.main" }}></Chip>;
};

export default SiteNumberTextField;
